import { Language } from '../../model/enums/language';
import { EditorTreeType } from '../editor-tree-service/editor-tree.constants';

export enum CookieName {
  Consent = 'Consent',
  Preferences = 'Preferences',
}

export enum CookieType {
  Required = 'required',
  Preferences = 'preferences',
  Performance = 'performance',
}

export interface CookieConsentCookie {
  type: CookieType.Required;
  preferences: boolean;
  performance: boolean;
  version: number;
}

export interface PreferencesCookie {
  type: CookieType.Preferences;
  consentedToToC?: boolean;
  shownOnboarding?: boolean;
  userLanguage?: Language;
  inventoryTree?: EditorTreeType.GPC | EditorTreeType.ActivityHierarchy | string;
}

export type ConsentOrPreferencesCookie<T> = T extends CookieName.Consent
  ? CookieConsentCookie
  : T extends CookieName.Preferences
    ? PreferencesCookie
    : null;

export type Preference = keyof Omit<PreferencesCookie, 'type'>;

export type PreferenceValue<T extends Preference> = T extends 'userLanguage'
  ? Language
  : T extends 'consentedToToC' | 'shownOnboarding'
    ? boolean
    : T extends 'inventoryTree'
      ? EditorTreeType.GPC | EditorTreeType.ActivityHierarchy | string
      : never;
